import React, { useEffect, useRef } from 'react';
import styles from './modal.module.css';
import { MyIcons } from '../../icons/my-icons';

const Modal = ({ isOpen, onClose, title, children, position, disableClickOutside = false }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!disableClickOutside && modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose, disableClickOutside]);

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div 
        className={styles.modalContainer} 
        style={position} 
        ref={modalRef}
      >
        <div className={styles.modalHeader}>
          {title && <h3 className={styles.modalTitle}>{title}</h3>}
          <button className={styles.closeButton} onClick={onClose}>
            <MyIcons name="close" width={18} height={18} color={" q"}/>
          </button>
        </div>
        <div className={styles.modalContent}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;